/* Tenuta La Nocellara — Baglio Collura Premium Highlight */
(function () {
  'use strict';

  var collectionUrl = '/collections/selezioni-limitate-tenuta-la-nocellara';
  var imageUrl = 'https://cdn.shopify.com/s/files/1/0279/7731/8509/files/baglio-collura-paesaggio-uliveto-2026.jpg?v=1791833511';
  var lang = (document.documentElement.lang || 'it').toLowerCase();
  var isItalian = lang.indexOf('it') === 0;

  var copy = isItalian ? {
    announcement: 'BAGLIO COLLURA 2026 · EDIZIONE LIMITATA · PROSSIMAMENTE',
    eyebrow: 'SELEZIONE LIMITATA · RACCOLTO 2026',
    title: 'Baglio Collura',
    meta: '600 ulivi · Calatafimi Segesta · Bottiglie numerate',
    text: 'Una raccolta. Un luogo. Una quantità limitata.',
    cta: 'Scopri la selezione',
    badgeTop: 'EDIZIONE',
    badgeMain: 'LIMITATA',
    menuBadge: 'PREMIUM',
    close: 'Chiudi annuncio'
  } : {
    announcement: 'BAGLIO COLLURA 2026 · LIMITED EDITION · COMING SOON',
    eyebrow: 'LIMITED SELECTION · HARVEST 2026',
    title: 'Baglio Collura',
    meta: '600 olive trees · Calatafimi Segesta · Numbered bottles',
    text: 'One harvest. One place. A limited quantity.',
    cta: 'Discover the selection',
    badgeTop: 'LIMITED',
    badgeMain: 'EDITION',
    menuBadge: 'PREMIUM',
    close: 'Close announcement'
  };

  function addStyles() {
    if (document.getElementById('baglio-premium-styles')) return;
    var style = document.createElement('style');
    style.id = 'baglio-premium-styles';
    style.textContent = `
      .baglio-topbar{position:relative;z-index:20;background:linear-gradient(90deg,#9b713d,#c5a265 50%,#9b713d);color:#12352b;text-align:center;min-height:40px;display:flex;align-items:center;justify-content:center;font-family:inherit;box-shadow:0 1px 0 rgba(255,255,255,.25) inset}
      .baglio-topbar__link{display:block;width:100%;padding:10px 50px 9px;color:#12352b!important;text-decoration:none!important;font-size:12px;font-weight:700;line-height:1.4;letter-spacing:.14em;text-transform:uppercase}
      .baglio-topbar__link:hover{opacity:.86}
      .baglio-topbar__close{position:absolute;right:12px;top:50%;transform:translateY(-50%);width:30px;height:30px;border:0;background:transparent;color:#12352b;font-size:23px;line-height:28px;cursor:pointer;padding:0}
      .baglio-home-feature{background:#12352b;color:#f7f1e7;width:100%;padding:0;margin:0}
      .baglio-home-feature__inner{max-width:1180px;margin:0 auto;display:grid;grid-template-columns:minmax(0,1.15fr) minmax(320px,.85fr);align-items:stretch}
      .baglio-home-feature__visual{position:relative;min-height:510px;overflow:hidden}
      .baglio-home-feature__visual img{position:absolute;inset:0;width:100%;height:100%;object-fit:cover;object-position:center;display:block}
      .baglio-home-feature__visual:after{content:'';position:absolute;inset:0;background:linear-gradient(90deg,rgba(18,53,43,.02),rgba(18,53,43,.2))}
      .baglio-home-feature__seal{position:absolute;z-index:2;right:26px;top:26px;width:105px;height:105px;border-radius:50%;display:flex;flex-direction:column;align-items:center;justify-content:center;text-align:center;background:radial-gradient(circle at 32% 25%,#ead39e 0,#c39a59 46%,#9b713d 100%);color:#12352b;border:1px solid rgba(255,255,255,.5);box-shadow:0 8px 30px rgba(0,0,0,.18);text-transform:uppercase;letter-spacing:.09em}
      .baglio-home-feature__seal strong{font-size:25px;line-height:1;font-family:inherit}
      .baglio-home-feature__seal span{font-size:9px;line-height:1.35;font-weight:700;margin-top:5px}
      .baglio-home-feature__content{display:flex;flex-direction:column;justify-content:center;padding:70px 60px}
      .baglio-home-feature__eyebrow{color:#c9a563;font-size:11px;line-height:1.4;font-weight:700;letter-spacing:.18em;text-transform:uppercase;margin:0 0 18px}
      .baglio-home-feature__title{color:#f7f1e7!important;font-size:48px;line-height:1.05;margin:0 0 22px;font-family:inherit;font-weight:400}
      .baglio-home-feature__meta{color:#e6d7b8;font-size:13px;line-height:1.6;font-weight:600;letter-spacing:.04em;margin:0 0 20px}
      .baglio-home-feature__text{font-size:20px;line-height:1.55;margin:0 0 32px;color:#f7f1e7}
      .baglio-home-feature__cta{align-self:flex-start;display:inline-block;padding:13px 25px;border:1px solid #c9a563;color:#f7f1e7!important;text-decoration:none!important;font-size:11px;font-weight:700;letter-spacing:.16em;text-transform:uppercase;transition:.2s ease}
      .baglio-home-feature__cta:hover{background:#c9a563;color:#12352b!important}
      .baglio-premium-badge{position:absolute;z-index:8;top:16px;right:16px;width:88px;height:88px;border-radius:50%;display:flex;flex-direction:column;align-items:center;justify-content:center;text-align:center;background:radial-gradient(circle at 32% 25%,#ead39e 0,#c39a59 48%,#956b38 100%);color:#12352b;border:1px solid rgba(255,255,255,.55);box-shadow:0 5px 18px rgba(0,0,0,.16);pointer-events:none;text-transform:uppercase;line-height:1.05}
      .baglio-premium-badge__top{font-size:8px;font-weight:700;letter-spacing:.12em;margin-bottom:3px}
      .baglio-premium-badge__main{font-size:11px;font-weight:800;letter-spacing:.08em}
      .baglio-premium-badge__year{font-size:8px;font-weight:700;letter-spacing:.12em;margin-top:4px}
      .baglio-menu-premium{display:inline-block;margin-left:7px;padding:2px 6px;border-radius:20px;background:#c39a59;color:#12352b;font-size:8px!important;line-height:1.4;font-weight:800;letter-spacing:.1em;vertical-align:middle;text-transform:uppercase;transform:translateY(-1px)}
      @media(max-width:749px){
        .baglio-topbar__link{font-size:10px;letter-spacing:.09em;padding:9px 42px 9px 12px}
        .baglio-home-feature__inner{display:block}
        .baglio-home-feature__visual{min-height:340px}
        .baglio-home-feature__seal{width:86px;height:86px;right:16px;top:16px}
        .baglio-home-feature__seal strong{font-size:21px}
        .baglio-home-feature__content{padding:48px 24px 54px;text-align:center;align-items:center}
        .baglio-home-feature__title{font-size:38px}
        .baglio-home-feature__text{font-size:18px}
        .baglio-home-feature__cta{align-self:center}
        .baglio-premium-badge{width:72px;height:72px;top:10px;right:10px}
        .baglio-premium-badge__top,.baglio-premium-badge__year{font-size:7px}
        .baglio-premium-badge__main{font-size:9px}

        /* Mobile hero spacing fix: keep the homepage logo clear of the headline. */
        body.template-index #shopify-section-slideshow .slideshow__text-container{top:120px!important;transform:none!important;padding-left:24px!important;padding-right:24px!important}
        body.template-index #shopify-section-slideshow .slideshow__text-content{max-width:100%!important}
        body.template-index #shopify-section-slideshow .slideshow__heading{font-size:22px!important;line-height:1.16!important;margin-top:0!important;margin-bottom:0!important}
        body.template-index #shopify-section-slideshow .slideshow__subtitle{font-size:13.5px!important;line-height:1.42!important;margin-top:12px!important}
        body.template-index #shopify-section-slideshow .slideshow__heading-cta{margin-top:15px!important}
      }
    `;
    document.head.appendChild(style);
  }

  function addAnnouncement() {
    if (document.querySelector('.baglio-topbar')) return;
    try {
      if (window.sessionStorage && sessionStorage.getItem('baglioAnnouncementClosed') === '1') return;
    } catch (e) {}
    var headerWrapper = document.querySelector('.site-header__wrapper');
    if (!headerWrapper) return;
    var bar = document.createElement('div');
    bar.className = 'baglio-topbar';
    bar.innerHTML = '<a class="baglio-topbar__link" href="' + collectionUrl + '">' + copy.announcement + '</a><button class="baglio-topbar__close" type="button" aria-label="' + copy.close + '">×</button>';
    headerWrapper.insertBefore(bar, headerWrapper.firstChild);
    var close = bar.querySelector('.baglio-topbar__close');
    close.addEventListener('click', function () {
      try { if (window.sessionStorage) sessionStorage.setItem('baglioAnnouncementClosed', '1'); } catch (e) {}
      bar.parentNode.removeChild(bar);
    });
  }

  function addHomeFeature() {
    if (!document.body.classList.contains('template-index') || document.querySelector('.baglio-home-feature')) return;
    var main = document.getElementById('MainContent');
    if (!main) return;
    var section = document.createElement('section');
    section.className = 'baglio-home-feature';
    section.setAttribute('aria-label', copy.title);
    section.innerHTML = '<div class="baglio-home-feature__inner">' +
      '<a class="baglio-home-feature__visual" href="' + collectionUrl + '">' +
        '<img src="' + imageUrl + '" alt="Baglio Collura, Calatafimi Segesta" loading="lazy">' +
        '<span class="baglio-home-feature__seal"><strong>600</strong><span>ULIVI<br>2026</span></span>' +
      '</a>' +
      '<div class="baglio-home-feature__content">' +
        '<p class="baglio-home-feature__eyebrow">' + copy.eyebrow + '</p>' +
        '<h2 class="baglio-home-feature__title">' + copy.title + '</h2>' +
        '<p class="baglio-home-feature__meta">' + copy.meta + '</p>' +
        '<p class="baglio-home-feature__text">' + copy.text + '</p>' +
        '<a class="baglio-home-feature__cta" href="' + collectionUrl + '">' + copy.cta + '</a>' +
      '</div>' +
    '</div>';
    var slideshow = document.getElementById('shopify-section-slideshow');
    if (slideshow && slideshow.parentNode) {
      slideshow.parentNode.insertBefore(section, slideshow.nextSibling);
    } else {
      main.insertBefore(section, main.firstChild);
    }
  }

  function addCardBadges() {
    var cards = document.querySelectorAll('.card');
    for (var i = 0; i < cards.length; i++) {
      var card = cards[i];
      if (card.querySelector('.baglio-premium-badge')) continue;
      var link = card.querySelector('a.card__wrapper[href*="/products/baglio-collura-"]');
      if (!link) continue;
      var badge = document.createElement('span');
      badge.className = 'baglio-premium-badge';
      badge.setAttribute('aria-hidden', 'true');
      badge.innerHTML = '<span class="baglio-premium-badge__top">' + copy.badgeTop + '</span><span class="baglio-premium-badge__main">' + copy.badgeMain + '</span><span class="baglio-premium-badge__year">2026</span>';
      link.appendChild(badge);
    }
  }

  function highlightMenu() {
    var links = document.querySelectorAll('.navigation__link a');
    for (var i = 0; i < links.length; i++) {
      var link = links[i];
      if (link.querySelector('.baglio-menu-premium')) continue;
      if (link.getAttribute('href') === collectionUrl || link.textContent.trim().toLowerCase() === 'baglio collura') {
        var premium = document.createElement('span');
        premium.className = 'baglio-menu-premium';
        premium.textContent = copy.menuBadge;
        link.appendChild(premium);
      }
    }
  }

  function initBaglioPremium() {
    addStyles();
    addAnnouncement();
    addHomeFeature();
    addCardBadges();
    highlightMenu();

    if (window.MutationObserver && document.body) {
      var observer = new MutationObserver(function () {
        addCardBadges();
        highlightMenu();
      });
      observer.observe(document.body, { childList: true, subtree: true });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initBaglioPremium);
  } else {
    initBaglioPremium();
  }
})();
